(function ($, Drupal) {
  Drupal.behaviors.polygonTooltip = {
    attach: function (context) {
      once('polygonTooltip', 'html', context).forEach(function () {
        function createTooltipFloor(floorNumber, available, preReserved, sold) {
          var tooltip = document.createElement('div');
          tooltip.className = 'polygon-tooltip';

          tooltip.innerHTML = `
    <p class="p-small !mb-2 text-gray-10">${floorNumber}</p>
    <hr/>
    <p class="!mb-0 flex justify-between">
      <span>${Drupal.t('Free flats', {}, { context: 'ganzhouse' })}</span>
      <span class="pl-6 font-bold flex">${available}</span>
    </p>
    <p class="!mb-0 flex justify-between">
      <span>${Drupal.t('Prereserved flats', {}, { context: 'ganzhouse' })}</span>
      <span class="pl-6 font-bold flex">${preReserved}</span>
    </p>
    <p class="!mb-0 flex justify-between">
      <span>${Drupal.t('Sold flats', {}, { context: 'ganzhouse' })}</span>
      <span class="pl-6 font-bold flex">${sold}</span>
    </p>
  `;

          return tooltip;
        }

        function createTooltipFlat(flatName, rooms, interier, exterier, status) {
          var tooltip = document.createElement('div');
          tooltip.className = 'polygon-tooltip';

          tooltip.innerHTML = `
            <p class="!mb-2 flex justify-between">
              <span class="font-bold">${flatName}</span>
              <span class="font-bold pl-6 flex">${status}</span>
            </p>
            <hr/>
            <p class="!mb-0 flex justify-between">
              <span>${Drupal.t('Rooms', {}, { context: 'ganzhouse' })}</span>
              <span class="pl-6 font-bold flex">${rooms}</span>
            </p>
            <p class="!mb-0 flex justify-between">
              <span>${Drupal.t('Interior', {}, { context: 'ganzhouse' })}</span>
              <span class="pl-6 font-bold flex">${interier} m²</span>
            </p>
            <p class="!mb-0 flex justify-between">
              <span>${Drupal.t('Exterior', {}, { context: 'ganzhouse' })}</span>
              <span class="pl-6 font-bold flex">${exterier} m²</span>
            </p>
          `;

          return tooltip;
        }

        function positionTooltip(tooltip, event) {
          const tooltipWidth = tooltip.offsetWidth;
          const tooltipHeight = tooltip.offsetHeight;
          const windowWidth = window.innerWidth;
          const windowHeight = window.innerHeight;

          let left = event.pageX + 10;
          let top = event.pageY - tooltipHeight - 10;

          if (left + tooltipWidth > windowWidth) {
            left = event.pageX - tooltipWidth - 10;
          }

          if (left < 0) {
            left = 10;
          }

          if (top < 0) {
            top = event.pageY + 10;
          }

          if (top + tooltipHeight > windowHeight) {
            top = windowHeight - tooltipHeight - 10;
          }

          tooltip.style.left = `${left}px`;
          tooltip.style.top = `${top}px`;
        }

        var floorPolygons = document.querySelectorAll('.floor-plan polygon');

        floorPolygons.forEach(function (polygon) {
          polygon.addEventListener('mouseenter', function () {
            var floorNumber = polygon.getAttribute('data-floornumber') || 'Unknown';
            var available = polygon.getAttribute('data-available') || 'Unknown';
            var preReserved = polygon.getAttribute('data-prereserved') || 'Unknown';
            var sold = polygon.getAttribute('data-sold') || 'Unknown';

            var tooltip = createTooltipFloor(floorNumber, available, preReserved, sold);
            document.body.appendChild(tooltip);

            polygon.addEventListener('mousemove', function (eventX) {
              positionTooltip(tooltip, eventX);
            });

            polygon.addEventListener('mouseleave', function () {
              tooltip.remove();
              polygon.removeEventListener('mousemove', positionTooltip);
            });
          });
        });

        var flatPolygons = document.querySelectorAll('.flat-plan polygon');

        flatPolygons.forEach(function (polygon) {
          polygon.addEventListener('mouseenter', function () {
            var flatName = polygon.getAttribute('data-flatname') || 'Unknown';
            var rooms = polygon.getAttribute('data-rooms') || 'Unknown';
            var interier = polygon.getAttribute('data-interier') || 'Unknown';
            var exterier = polygon.getAttribute('data-exterier') || 'Unknown';
            var status = polygon.getAttribute('data-status') || 'Unknown';

            var tooltip = createTooltipFlat(flatName, rooms, interier, exterier, status);
            document.body.appendChild(tooltip);

            polygon.addEventListener('mousemove', function (eventX) {
              positionTooltip(tooltip, eventX);
            });

            polygon.addEventListener('mouseleave', function () {
              tooltip.remove();
              polygon.removeEventListener('mousemove', positionTooltip);
            });
          });
        });
      });
    },
  };
}(jQuery, Drupal));
